import { SelectOptionType } from '@octano/global-ui';

/**
 * Catálogos SNIES de caracterización (HU 16033) para HIDRATAR los selects de la ficha
 * de reformada. Espejo del backend `snies-characterization.catalog.ts`: si cambia uno,
 * actualizar el otro. Se usan en studentFileNewFormatPreviusData (getSelectedOption).
 */
export const ethnicPopulationOptions: SelectOptionType[] = [
  { value: '0', label: 'No Informa' },
  { value: '1', label: 'Pueblo indígena' },
  { value: '2', label: 'Comunidad negra' },
  { value: '3', label: 'Pueblo RROM' },
  { value: '4', label: 'No pertenece' },
];
export const indigenousPeopleOptions: SelectOptionType[] = [
  { value: '0', label: 'No aplica' },
  { value: '1', label: 'Achagua' },
  { value: '2', label: 'Amorúa' },
  { value: '3', label: 'Andoque o andoke' },
  { value: '4', label: 'Arhuaco (ijka)' },
  { value: '5', label: 'Awa (cuaiker)' },
  { value: '6', label: 'Barea' },
  { value: '7', label: 'Barí (motilón)' },
  { value: '8', label: 'Betoye' },
  { value: '9', label: 'Bara' },
  { value: '10', label: 'Cañamomo' },
  { value: '11', label: 'Carapana' },
  { value: '12', label: 'Carijona o karijona' },
  { value: '13', label: 'Chimila (ette e´neka)' },
  { value: '14', label: 'Chiricoa' },
  { value: '15', label: 'Cocama' },
  { value: '16', label: 'Coconuco' },
  { value: '17', label: 'Coyaima-Natagaima' },
  { value: '18', label: 'Pijaos' },
  { value: '19', label: 'Cubeo o kubeo' },
  { value: '20', label: 'Cuiba o kuiba' },
  { value: '21', label: 'Curripaco o kurripaco' },
  { value: '22', label: 'Desano' },
  { value: '23', label: 'Dujos' },
  { value: '24', label: 'Embera catio o katío' },
  { value: '25', label: 'Embera chami' },
  { value: '26', label: 'Eperara siapidara' },
  { value: '27', label: 'Guambiano' },
  { value: '28', label: 'Guanaca' },
  { value: '29', label: 'Guane' },
  { value: '30', label: 'Guyabero' },
  { value: '31', label: 'Hitnú' },
  { value: '32', label: 'Hupdu' },
  { value: '33', label: 'Inga' },
  { value: '34', label: 'Juhup' },
  { value: '35', label: 'Kamsa o kamëntsá' },
  { value: '36', label: 'Kankuamo' },
  { value: '37', label: 'Kakua' },
  { value: '38', label: 'Kogui' },
  { value: '39', label: 'Koreguaje o coreguaje' },
  { value: '40', label: 'Letuama' },
  { value: '41', label: 'Macaguaje o makaguaje' },
  { value: '42', label: 'Nukak (makú)' },
  { value: '43', label: 'Macuna o makuna (sara)' },
  { value: '44', label: 'Masiguare' },
  { value: '45', label: 'Matapí' },
  { value: '46', label: 'Miraña' },
  { value: '47', label: 'Mokaná' },
  { value: '48', label: 'Muinane' },
  { value: '49', label: 'Muisca' },
  { value: '50', label: 'Nonuya' },
  { value: '51', label: 'Ocaina' },
  { value: '52', label: 'Nasa (paéz)' },
  { value: '53', label: 'Pastos' },
  { value: '54', label: 'Piapoco (dzase)' },
  { value: '55', label: 'Piaroa' },
  { value: '56', label: 'Piratapuyo' },
  { value: '57', label: 'Pisamira' },
  { value: '58', label: 'Puinave' },
  { value: '59', label: 'Sánha' },
  { value: '60', label: 'Sikuani' },
  { value: '61', label: 'Siona' },
  { value: '62', label: 'Siriano' },
  { value: '63', label: 'Siripu o tsiripu (mariposo)' },
  { value: '64', label: 'Taiwano (tajuano)' },
  { value: '65', label: 'Tanimuka' },
  { value: '66', label: 'Tariano' },
  { value: '67', label: 'Tatuyo' },
  { value: '68', label: 'Tikuna' },
  { value: '69', label: 'Tororó' },
  { value: '70', label: 'Tucano (desea) o tukano' },
  { value: '71', label: 'Tule (kuna)' },
  { value: '72', label: 'Tuyuka (dojkapuara)' },
  { value: '73', label: 'U´wa (tunebo)' },
  { value: '74', label: 'Wanano' },
  { value: '75', label: 'Wayuu' },
  { value: '76', label: 'Witoto - huitoto' },
  { value: '77', label: 'Wiwa (arzario)' },
  { value: '78', label: 'Waunan (wuanana)' },
  { value: '79', label: 'Yagua' },
  { value: '80', label: 'Yanacona' },
  { value: '81', label: 'Yauna' },
  { value: '82', label: 'Yukuna' },
  { value: '83', label: 'Yuko (yukpa)' },
  { value: '84', label: 'Yurí (carabayo)' },
  { value: '85', label: 'Yuruti' },
  { value: '86', label: 'Zenú / senú' },
  { value: '87', label: 'Quillacingas' },
  { value: '88', label: 'No informa' },
  { value: '89', label: 'Otro' },
];
export const blackCommunityOptions: SelectOptionType[] = [
  { value: '0', label: 'No Aplica' },
  { value: '1', label: 'Afrocolombianos' },
  { value: '2', label: 'Raizales' },
  { value: '3', label: 'Palenqueros' },
  { value: '4', label: 'Otras comunidades negras' },
];
export const disabilityOptions: SelectOptionType[] = [
  { value: '0', label: 'No Informa' },
  { value: '1', label: 'Si' },
  { value: '2', label: 'No' },
];
export const disabilityTypeOptions: SelectOptionType[] = [
  { value: '0', label: 'No Aplica' },
  { value: '1', label: 'Discapacidad Sensorial - Sordera Profunda' },
  { value: '2', label: 'Discapacidad Sensorial - Hipoacusia' },
  { value: '3', label: 'Discapacidad Sensorial - Ceguera' },
  { value: '4', label: 'Discapacidad Sensorial - Baja Visión' },
  { value: '5', label: 'Discapacidad Sensorial - Sordoceguera' },
  { value: '6', label: 'Discapacidad Intelectual' },
  { value: '7', label: 'Discapacidad Psicosocial' },
  { value: '8', label: 'Discapacidad Múltiple' },
  { value: '9', label: 'Discapacidad Fisica o motora' },
  { value: '10', label: 'Discapacidad Sistémica' },
];
export const exceptionalTalentOptions: SelectOptionType[] = [
  { value: '0', label: 'No aplica' },
  { value: '1', label: 'Talento excepcional general' },
  { value: '2', label: 'Talento excepcional específico' },
];
